var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenCheck = function SvgGreenCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80C0 124.112 35.888 160 80 160C124.112 160 160 124.112 160 80C160 35.888 124.112 0 80 0C35.888 0 0 35.888 0 80ZM121.657 65.6568C124.781 62.5327 124.781 57.4673 121.657 54.3431C118.533 51.2189 113.467 51.2189 110.343 54.3431L72 92.6863L53.6568 74.3431C50.5327 71.2189 45.4673 71.2189 42.3431 74.3431C39.2189 77.4673 39.2189 82.5327 42.3431 85.6569L66.3431 109.657C69.4673 112.781 74.5327 112.781 77.6569 109.657L121.657 65.6568Z",
    fill: "#52B026"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greenCheck.67b26275.svg";
export { ForwardRef as ReactComponent };